"use client";

import { Zap } from "lucide-react";

interface SessionLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SessionLimitModal({ isOpen, onClose }: SessionLimitModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ animation: "fadeIn 0.15s ease-out" }}>
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative bg-card border border-border rounded-2xl shadow-2xl p-6 max-w-md w-full"
        style={{ animation: "popIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)" }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-indigo-500 to-pink-500 flex items-center justify-center">
            <Zap className="h-5 w-5 text-white" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground">Session Limit Reached</h3>
            <p className="text-xs text-muted-foreground">You&apos;ve used all 5 free sessions.</p>
          </div>
        </div>

        <a
          href="/pricing"
          className="block rounded-xl bg-gradient-to-r from-indigo-500 to-pink-500 p-4 text-white mb-4 hover:shadow-lg hover:shadow-indigo-500/20 transition-all"
        >
          <p className="font-semibold text-sm mb-1">Upgrade to sensei. Pro</p>
          <ul className="text-xs text-white/80 space-y-0.5">
            <li>• Unlimited sessions</li>
            <li>• 10× more tokens per chat</li>
            <li>• Upload up to 5 files</li>
          </ul>
          <span className="inline-block mt-2 text-xs font-semibold bg-white/20 rounded-lg px-3 py-1">
            Upgrade Now →
          </span>
        </a>

        <button
          onClick={onClose}
          className="w-full h-9 rounded-xl bg-muted hover:bg-muted/80 text-muted-foreground text-sm font-medium transition-colors"
        >
          Dismiss
        </button>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes popIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
      `}</style>
    </div>
  );
}
